import { useSelector } from 'react-redux';

import type { RootState } from '../store/index.js';
import { canViewSecurityPage } from '../lib/security-page-access.js';

export function useCanViewSecurityPage(): boolean {
  const user = useSelector((state: RootState) => state.auth.user);
  const role = useSelector((state: RootState) => state.auth.role);
  return canViewSecurityPage(user, role);
}
